import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const ZoneIcon = ({ fill='#4EE4B3', border='#000', ...props}) => {
  return (
    <Icon viewBox="0 0 62 71" {...props}>
      <g fill="none">
        <path
          fill={border}
          d="M30.6895,0 C13.7675,0 0.0005,12.901 0.0005,28.76 C0.0005,35.369 4.8795,44.316 14.5025,55.353 C21.4515,63.322 28.2915,69.417 28.5785,69.672 C29.1705,70.198 29.9295,70.461 30.6895,70.461 C31.4495,70.461 32.2085,70.198 32.8005,69.672 C33.0885,69.417 39.9275,63.322 46.8765,55.353 C56.4995,44.316 61.3795,35.369 61.3795,28.76 C61.3795,12.901 47.6115,0 30.6895,0"
        />
        <path
          fill={fill}
          d="M30.6895,63.5683 C22.2725,55.6923 6.1375,38.5683 6.1375,28.7593 C6.1375,16.0723 17.1515,5.7523 30.6895,5.7523 C44.2275,5.7523 55.2415,16.0723 55.2415,28.7593 C55.2415,38.5583 39.1045,55.6893 30.6895,63.5683"
        />
        <path
          fill={border}
          d="M43.8897,22.7373 L42.9007,21.7433 C41.8597,20.6983 40.1527,20.6943 39.1067,21.7353 L25.9987,34.7843 L20.8367,29.5983 C19.7957,28.5533 18.0877,28.5493 17.0427,29.5903 L16.0487,30.5793 C15.0027,31.6203 14.9987,33.3273 16.0397,34.3733 L23.0957,41.4603 L24.0847,42.4543 C25.1257,43.4993 26.8327,43.5033 27.8787,42.4623 L28.8717,41.4733 L43.8817,26.5313 C44.9277,25.4903 44.9307,23.7833 43.8897,22.7373"
        />
      </g>
    </Icon>
  );
};

ZoneIcon.propTypes = {
  fill: PropTypes.string,
  border: PropTypes.string,
};

export default ZoneIcon;
